import { Alert, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const VerifyID: React.FC = () => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'settings' });
  const { t: tGlobal } = useTranslation('dashboard', { keyPrefix: 'global' });

  return (
    <Alert
      icon={false}
      variant='outlined'
      severity='info'
      action={
        <Button
          component={Link}
          to='/account/settings#identity_verification'
          variant='contained'
          color='primary'
          sx={{ margin: 'auto' }}
        >
          {tGlobal('verify_now')}
        </Button>
      }
    >
      <Stack spacing={1}>
        <Typography variant='h6' fontWeight={700} color='primary'>
          {t('id_verification_title')}
        </Typography>
        <Typography variant='body2' fontWeight={500}>
          <Trans t={t} i18nKey='id_verification_description' components={{ br: <br /> }} />
        </Typography>
      </Stack>
    </Alert>
  );
};

export default VerifyID;
